"use strict";
// TODO regions.ts :: Remove hardcoded province/region names (values of keys in allRegions)
// TODO regions.ts :: Make only province/region codes (keys) array export
// TODO regions.ts :: Uppercase province/region codes (keys)
// TODO regions.ts :: Removed unneeded exports
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._regions = {
    AB: 'AB',
    BC: 'BC',
    MB: 'MB',
    NB: 'NB',
    NL: 'NL',
    NT: 'NT',
    NS: 'NS',
    NU: 'NU',
    ON: 'ON',
    PE: 'PE',
    QC: 'QC',
    SK: 'SK',
    YT: 'YT',
};
/**
 * Array of all regions, in this format: ['AB', 'BC', ...]
 */
exports.regionArray = Object.keys(exports._regions);
// Memoize translated region object
var _storedRegionObj = null;
/**
 * Build a region object where values = the region name in the current language
 * E.g. if English: {AB: 'Alberta', BC: 'British Columbia', ...}
 */
exports.buildRegionObj = function (translate) {
    if (_storedRegionObj)
        return _storedRegionObj;
    _storedRegionObj = exports.regionArray.reduce(function (acc, region) {
        var _a;
        return (__assign({}, acc, (_a = {}, _a[region] = translate(region), _a)));
    }, {});
    return _storedRegionObj;
};
/**
 * Get region name from region abbreviation/ID & translate function
 */
exports.getRegionName = function (translate, regionAbbrevId) {
    return exports.buildRegionObj(translate)[regionAbbrevId.toUpperCase()];
};
//# sourceMappingURL=regions.js.map